/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Profile } from '@administration-client/user-shared';
import { Component, input, InputSignal } from '@angular/core';
import { StateResource } from '@common/tech-shared';
import { SpinnerComponent } from '@odc/component';
import { ErrorMessageComponent, UserIconComponent } from '@ods/system';
import { ChangePasswordContainerComponent } from '../../change-password/change-password-container.component';

@Component({
  selector: 'administration-profile-data',
  imports: [ChangePasswordContainerComponent, ErrorMessageComponent, SpinnerComponent, UserIconComponent],
  templateUrl: './profile-data.component.html',
})
export class ProfileDataComponent {
  public readonly profile: InputSignal<Profile> = input.required<Profile>();
  public readonly organisationsEinheitenStateResource: InputSignal<StateResource<string[]>> =
    input.required<StateResource<string[]>>();
}
